import {RefObject} from 'react';
import {SectionsRefs} from './types';
import {TestDashboardSectionID} from '../../types';

const initialRefObject: RefObject<HTMLElement> = {current: null};

export const initialSectionsRefs: SectionsRefs = {
	[TestDashboardSectionID.Sessions]: initialRefObject,
};
